module.exports = __webpack_public_path__ + "img/n5.38ffe183.jpg";